import { Checkbox, ListItem, ListItemIcon } from "@material-ui/core";
import { MouseEventHandler } from "react";
import ChampionBelt from "./champion-belt";
import { TasterAvatar, TasterName } from './taster-list-item.styles';

export type TasterListItemProps = {
    taster: string | null,
    onClick?: MouseEventHandler<HTMLDivElement>,
    selected?: boolean,
    disabled?: boolean,
    selectable?: boolean,
    isChampion?: boolean,
}


const TasterListItem = ({
    taster,
    onClick,
    disabled = false,
    selected = false,
    selectable = false,
    isChampion = false,
}: TasterListItemProps) => {
    const ItemComponent = (p: any) => (
        selectable ? <ListItem {...p} button /> : <ListItem {...p} />
    );
    const championBackground = isChampion && !selectable
        ? "linear-gradient(90deg, rgba(255,214,107,0.18) 0%, rgba(255,214,107,0) 70%)"
        : undefined;
    return (
        <ItemComponent
            onClick={onClick}
            divider
            disabled={disabled}
            style={championBackground ? { background: championBackground } : undefined}
        >
            {selectable ? (
                <ListItemIcon>
                    <Checkbox
                        edge="start"
                        checked={selected}
                        tabIndex={-1}
                        disableRipple
                    />
                </ListItemIcon>
            ) : (
                <TasterAvatar name={taster ?? ""} />
            )}
            <TasterName
                primaryTypographyProps={isChampion ? { style: { fontWeight: 700 } } : undefined}
            >
                {taster}
            </TasterName>
            {isChampion && !selectable && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        marginLeft: "auto",
                    }}
                >
                    <ChampionBelt size={20} />
                    <span
                        style={{
                            fontSize: 9.5,
                            fontWeight: 800,
                            color: "#8A5410",
                            letterSpacing: 0.7,
                            textTransform: "uppercase",
                        }}
                    >
                        Champ
                    </span>
                </div>
            )}
        </ItemComponent>
    );
};
export default TasterListItem;
